import React from 'react';
import CertificationSection from '../components/certifications/index';
import { Heading3 } from '../typography/typography';
import Fade from 'react-reveal/Fade';

export default function CertificationsContainer () {

    let slides = [
        <CertificationSection.CarousalSlide  src="/images/js.jpg" alt="1" />,
        <CertificationSection.CarousalSlide  src="/images/awbc.jpg" alt="2" />,
        <CertificationSection.CarousalSlide  src="/images/dl.jpg" alt="3" />,
        <CertificationSection.CarousalSlide  src="/images/nlp.jpg" alt="4" />,
    ];
    return <CertificationSection id="certifications">
                <Heading3>CERTIFICATIONS</Heading3>
                <Fade>
                    <CertificationSection.Carousal slides = {slides} />
                </Fade>
             </CertificationSection>
}